import { Deserializable } from '../interfaces';

export class RememberUser implements Deserializable {
  userName: string;
  pwd: string;

  constructor() {
    this.userName = '';
    this.pwd = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
